"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySubstitutionsToTemplate = applySubstitutionsToTemplate;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function applySubstitutionsToTemplate(templateText, substitutions) {
    return substitutions.reduce((text, template) => {
        const regex = new RegExp(`{{\\s*${template.name}\\s*}}`, 'g');
        return text.replace(regex, sigma_engine_shared_1.Utils.resolveValueFromThunk(template.value));
    }, templateText);
}
//# sourceMappingURL=templating.js.map